<app-page-content>
    <div class="layout mt-3">
        <div class="mx-5 px-2 mt-2">
            <ng-content></ng-content>
        </div>
    </div>
</app-page-content>